<div class="navbar zone-dark">
  <div class="navbar-container">
    <div *ngIf="isExperimentalActive" class="navbar-experimental-badge">
      <lui-avatar
        class="navbar-experimental-badge-icon"
        [size]="36"
        matTooltip="Experimental mode is active"
        color="orange"
        i18n-matTooltip
      >
        <mat-icon svgIcon="flag"></mat-icon>
      </lui-avatar>
    </div>
    <div class="navbar-logo">
      <ng-content select="[luiNavbarLogo]"></ng-content>
    </div>

    <div class="navbar-end">
      <ng-content select="[luiNavbarEnd]"></ng-content>
    </div>
  </div>

  <div class="navbar-divider"></div>
</div>
